import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import PrepaidAmountInput from '@components/prepaid/PrepaidAmountInput';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import { useQuery } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_BALANCE_WON } from '../../../_shared/constants';
import useDailyMaxMan from '../../../_shared/hooks/useDailyMaxMan';

interface Props {
    cardId: string;
    initialAmount?: number;
}

function ChargeAmount({ cardId, initialAmount }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { amount, setAmount } = useContext(PrepaidContext);
    const { data } = useQuery(userPrepaidCardQueries.detail(cardId));
    const balance = data?.balance ?? 0;
    const dailyMaxMan = useDailyMaxMan();
    const maxParams = { max: dailyMaxMan, maxWon: (dailyMaxMan * 10000).toLocaleString() };

    const errorText = (() => {
        if (amount <= 0) return undefined;
        if (amount > dailyMaxMan) return t('charge.errorDaily', maxParams);
        if (balance + amount * 10000 > MAX_BALANCE_WON) return t('charge.errorMaxBalance');
        return undefined;
    })();

    useEffect(() => {
        if (initialAmount) {
            setAmount(Math.max(initialAmount / 10000, 0));
        }
    }, [initialAmount, setAmount]);

    return (
        <PrepaidAmountInput
            amountMan={amount}
            onChangeMan={setAmount}
            errorText={errorText}
            placeholder={t('charge.amountPlaceholder', maxParams)}
            tooltipDaily={t('charge.tooltipDaily', maxParams)}
            tooltipMaxBalance={t('charge.tooltipMaxBalance')}
        />
    );
}

export default ChargeAmount;
